<template>
    <div class="h-100 w-100">
        <div 
            class="d-flex flex-column justify-content-center align-items-center drop-image-zone"
            v-if="!imageFile.preview"
            @click="trigger()"
        >
            <b-icon icon="image-fill" font-scale="2"></b-icon>
            <h4 class="text-h4 my-2">
                กดเพื่ออัพโหลดรูปสินค้า
            </h4>
        </div>
        
        <div class="cursor-pointer" v-else @click="trigger()">
            <img :src="imageFile.preview" height="250" width="100%" alt="image file">
        </div>
        <input 
            ref="uploadImage" 
            type="file" 
            accept=".jpg, .png, .jpeg" 
            @change="uploadImage" 
            hidden
        />
    </div>
</template>

<script>
export default {
    props:{
        imageFile: {
            type: Object,
            default: () => {
                return {
                    file: null,
                    preview: null,
                }
            }
        }
    },
    methods:{
        trigger(){
          this.$refs.uploadImage.click()
        },
        uploadImage(file){
            if (file.target.files.length < 1) return false;
            const fileReader = new FileReader();
            const { files } = file.target
            if (files && files.length) {
                this.imageFile.file = files[0];
                fileReader.readAsDataURL(files[0])
                fileReader.onload = () => {
                    if (typeof fileReader.result === 'string'){
                        this.imageFile.preview = fileReader.result
                    }
                }
            }
        }
    }
}
</script>
